/* eslint-disable */
import React, { useEffect, useState, useReducer } from 'react'
import Select from 'react-select'
import { Card, CardBody, Modal, ModalHeader, ModalBody, ModalFooter, Button, Label, Input, Row, Col, InputGroup, InputGroupText, FormFeedback, Form } from 'reactstrap'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { Controller, useForm } from 'react-hook-form'
import { GridComponent, ColumnsDirective, ColumnDirective, ColumnChooser, CommandColumn, Edit, Filter, Group, Inject, Page, Sort, Toolbar, Selection, ExcelExport, PdfExport } from '@syncfusion/ej2-react-grids'
import Avatar from "@components/avatar"
import toast from 'react-hot-toast'
import { Check, X } from "react-feather"
import { italian } from '../../../../@core/translation-syncfusion/grid-translation/it-IT'
import { L10n, setCulture } from '@syncfusion/ej2-base'
import { configGetListini, configSetListini, configDeleteListini } from '../../../../@core/auth/apiService/configs'
import Swal from 'sweetalert2'
import axios from 'axios'
//SET TRADUZIONE
setCulture('it-IT')
L10n.load(italian)

//VARIABILI CHE MI SERVE INIZIALIZZARE SIN DA SUBITO
let finalPrice
let grid
let recordToDelete

const reducer = (state, { type, payload }) => {
    switch (type) {
        case 'AGGIUNGI_LISTINONUOVO':
            return {
                id: '',
                nome: '',
                abilitato: 1,
                predefinito: 0,
                valorePartenza: 'COSTO',
                movimentazioneEuro: '+',
                movimentazionePercentuale: '+',
                valoreEuro: '',
                valorePercentuale: '',
                formula: '',
            }
        case 'LISTINO_PARTENZA':
            return {
                id: payload.id || '',
                nome: payload.nome || '',
                abilitato: payload.abilitato || '',
                predefinito: 0,
                valorePartenza: payload.valorePartenza || '',
                movimentazioneEuro: payload.movimentazioneEuro || '',
                movimentazionePercentuale: payload.movimentazionePercentuale || '',
                valoreEuro: payload.valoreEuro || '',
                valorePercentuale: payload.valorePercentuale || '',
                formula: payload.valorePartenza || '' + ' ' + payload.movimentazionePercentuale || '' + ' ' + payload.valorePercentuale || '' + ' % ' + payload.movimentazioneEuro || '' + ' ' + payload.valoreEuro || '' + ' Euro'
            }
        case 'MODIFICA_ABILITATO':
            if (payload.target.checked === false) { return ({ ...state, abilitato: 0 }) }
            else return { ...state, abilitato: 1 }
        case 'MODIFICA_PREDEFINITO':
            if (payload.target.checked === false) { return ({ ...state, predefinito: 0 }) }
            else return { ...state, predefinito: 1 }
        case 'MODIFICA_NOMELISTINO':
            return { ...state, nome: payload }
        case 'MODIFICA_VALOREPARTENZA':
            return { ...state, valorePartenza: payload }
        case 'MODIFICA_VALOREEURO':
            return { ...state, valoreEuro: payload }
        case 'MODIFICA_VALOREPERCENTUALE':
            return { ...state, valorePercentuale: payload }
        case 'MODIFICA_MOVIMENTAZIONEEURO':
            if (payload.target.id === 'ex2-inactive') { return ({ ...state, movimentazioneEuro: '-' }) }
            else return { ...state, movimentazioneEuro: '+' }
        case 'MODIFICA_MOVIMENTAZIONEPERCENTUALE':
            if (payload.target.id === 'ex1-inactive') { return ({ ...state, movimentazionePercentuale: '-' }) }
            else return { ...state, movimentazionePercentuale: '+' }
    }
}

const initialState = {
    id: '',
    nome: '',
    abilitato: '',
    predefinito: '',
    valorePartenza: '',
    movimentazionePercentuale: '',
    valorePercentuale: '',
    movimentazioneEuro: '',
    valoreEuro: '',
    formula: '',
}
// SETTAGGI PER LA GRID DA QUI A RIGA 153 
// SETTAGGI PER LA GRID DA QUI A RIGA 153 
// SETTAGGI PER LA GRID DA QUI A RIGA 153 

const optionsPartenza = [
    { value: 'COSTO', label: 'COSTO' },
    { value: 'PREZZO', label: 'PREZZO' },
    { value: 'MANUALE', label: 'MANUALE' }
]

const constructor = {

    editOptions: { allowEditing: true, allowDeleting: true },
    commands:
        [
            {
                type: 'Modifica',
                id: 'modifica',
                buttonOption: {
                    iconCss: 'e-icons e-edit',
                    cssClass: 'e-flat'
                }
            },
            {
                type: 'Elimina',
                id: 'eliminaSingolo',
                buttonOption: {
                    iconCss: 'e-icons e-trash',
                    cssClass: 'e-flat'
                }
            }
        ]
}


const toolbarCustomItem = [
    { text: 'Aggiungi', tooltipText: 'Aggiungi Listino', prefixIcon: 'e-plus', id: 'aggiungiListino' },
    { text: 'Elimina', tooltipText: 'Elimina', prefixIcon: 'e-delete', id: 'Elimina' },
    { text: 'PdfExport', id: 'grid_pdfexport' },
    { text: 'ExcelExport', id: 'grid_excelexport' },
    { text: 'CsvExport' },
    { text: 'Print' },
    'ColumnChooser',
    { text: 'Search' }
]
function abilitatoTemplate(data) {
    if (data.abilitato === 1) {
        return (<Avatar color="success" icon={<Check color='white' size={15} />}></Avatar>)
    } else if (data.abilitato === 0) {
        return (<Avatar color="danger" icon={<X color='white' size={15} />}></Avatar>)
    }
}
function predefinitoTemplate(data) {

    if (data.predefinito === 1) {
        return (<Avatar color="success" icon={<Check color='white' size={15} />}></Avatar>)
    } else if (data.predefinito === 0) {
        return (<Avatar color="danger" icon={<X color='white' size={15} />}></Avatar>)
    }
}

const rowSelected = () => { }
const defaultSchema = yup.object().shape({
    nome: yup.string().required(),
    valoreEuro: yup.number().required(),
    valorePercentuale: yup.number().required()
})
//FINE SETTAGGI PER LA GRID - INIZIO A RIGA 90
//FINE SETTAGGI PER LA GRID - INIZIO A RIGA 90
//FINE SETTAGGI PER LA GRID - INIZIO A RIGA 90


const DetailsPricesAndList = (props) => {
    //STATE
    const [basicModal, setBasicModal] = useState(false)
    const [listiniDataSource, setListiniDataSource] = useState([])
    const { costo, prezzo } = props
    const [state, dispatch] = useReducer(reducer, initialState)
    //useForm per la validazione
    const {
        control,
        reset,
        handleSubmit,
        formState: { errors }
    } = useForm({ mode: 'onChange', resolver: yupResolver(defaultSchema) })

    const onSubmit = () => {
        setBasicModal(!basicModal)
        chiamataSetListini()
    }
    const onError = (errors, e) => {
        toast.error('Modifica non eseguita, controlla i campi richiesti', {
            position: "top-right",
            duration: 3000,
            style: {
                background: 'red',
                color: 'white'
            }
        })
    }


    const alertAndConfirm = (id, itemId) => {
        Swal.fire({
            title: 'Sei Sicuro?',
            text: 'Verranno rimossi permanentemente',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ok',
            cancelButtonText: 'Annulla',
            customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-outline-danger ml-1'
            },
            buttonsStyling: false
        }).then(res => {
            if (res.value) {
                if (id === "Elimina") {

                    if (grid) {
                        recordToDelete = grid.getSelectedRecords()
                        recordToDelete.forEach(el => { grid.deleteRecord('id', el) })
                        recordToDelete = recordToDelete.map(el => ({ id: el.id }))
                    }
                    deleteListino(recordToDelete)
                } else if (id === "eliminaSingolo") {
                    grid.deleteRecord('id', itemId)
                    deleteListino([{ id: itemId.id }])
                }

            }
        })
    }
    //BOTTONI AZIONI INTERNI ALLE ROW
    const customButton = (args) => {
        if (args.commandColumn.id === 'modifica') {
            dispatch({ type: 'LISTINO_PARTENZA', payload: args.rowData })
            setBasicModal(!basicModal)
        }
        if (args.commandColumn.id === 'eliminaSingolo') {
            alertAndConfirm(args.commandColumn.id, args.rowData)
        }
    }
    // BUTTONS AZIONI DELLA TOOLBAR 
    const clickHandler = (args) => {
        if (args.item.id === 'Elimina') alertAndConfirm(args.item.id)
        if (args.item.id === 'aggiungiListino') {
            dispatch({ type: 'AGGIUNGI_LISTINONUOVO' })
            setBasicModal(!basicModal)
        }
        if (args.item.id === 'grid_pdfexport') {
            grid.pdfExport()
        } else if (args.item.id === 'grid_excelexport') {
            grid.excelExport()
        } else if (args.item.id === 'grid_csvexport') {
            grid.csvExport()
        }
    }


    const prezzoFinale = (i) => {
        let newPrezzo
        switch (listiniDataSource[i].valorePartenza) {
            case 'COSTO':
                newPrezzo = eval(costo + listiniDataSource[i].movimentazionePercentuale + eval(listiniDataSource[i].valorePercentuale / 100 * costo) + listiniDataSource[i].movimentazioneEuro + listiniDataSource[i].valoreEuro)
                return newPrezzo
            case 'PREZZO':
                newPrezzo = eval(prezzo + listiniDataSource[i].movimentazionePercentuale + eval(listiniDataSource[i].valorePercentuale / 100 * costo) + listiniDataSource[i].movimentazioneEuro + listiniDataSource[i].valoreEuro)
                return newPrezzo
            case 'MANUALE':
                newPrezzo = 0
                return newPrezzo

        }
    }

    const popolaPrezzo = () => {
        listiniDataSource.forEach((e, i) => {
            finalPrice = prezzoFinale(i)
            e.prezzo = finalPrice.toFixed(2)
        })
    }

    // DA QUI FINO A RIGA 338 SONO LE CHIAMATE CHE UTILIZZO
    // DA QUI FINO A RIGA 338 SONO LE CHIAMATE CHE UTILIZZO
    // DA QUI FINO A RIGA 338 SONO LE CHIAMATE CHE UTILIZZO

    // CHIAMATA SET LISTINI 
    const chiamataSetListini = async () => {
        const myResponse = await axios(configSetListini(JSON.stringify([state])))
        if (myResponse.data.esito === 'OK') {
            // analizza che sia un'aggiunta
            if (!listiniDataSource.find(element => element.id == myResponse.data.listini[0].id)) {
                listiniDataSource.push(state)
                state.id = myResponse.data.listini[0].id
                state.formula = state.valorePartenza + ' ' + state.movimentazionePercentuale + ' ' + state.valorePercentuale + ' % ' + state.movimentazioneEuro + ' ' + state.valoreEuro + ' Euro'
                popolaPrezzo()
                grid.refresh()
            } else {
                //nel caso sia una modifica
                grid.deleteRecord('id', myResponse.data.listini[0])
                listiniDataSource.push(state)
                state.id = myResponse.data.listini[0].id
                state.formula = state.valorePartenza + ' ' + state.movimentazionePercentuale + ' ' + state.valorePercentuale + ' % ' + state.movimentazioneEuro + ' ' + state.valoreEuro + ' Euro'
                popolaPrezzo()
                grid.refresh()
            }
            toast.success('Listino modificato/aggiunto con successo', {
                position: "top-right",
                duration: 3000,
                style: {
                    background: 'green',
                    color: 'white'
                }
            })
        } else {
            {
                toast.error('Si è verificato un errore durante la richiesta al server', {
                    position: "top-right",
                    duration: 3000,
                    style: {
                        background: 'red',
                        color: 'white'
                    }
                })
            }
        }
    }

    // CHIAMATA ELIMINA LISTINI 
    const deleteListino = async (itemId) => {
        const myResponse = await axios(configDeleteListini(JSON.stringify(itemId)))
        if (myResponse.data.esito === 'OK') {
            toast.success('Listino/i eliminato/i con successo', {
                position: "top-right",
                duration: 3000,
                style: {
                    background: 'green',
                    color: 'white'
                }
            })
        } else {
            {
                toast.error('Si è verificato un errore durante la richiesta al server', {
                    position: "top-right",
                    duration: 3000,
                    style: {
                        background: 'red',
                        color: 'white'
                    }
                })
            }

        }
    }
    //CHIAMATA GET LISTINI
    const getListini = async (setData) => {
        const myResponse = await axios(configGetListini({}))
        if (myResponse.data.esito === 'OK') {
            const listini = myResponse.data.listini
            setData(listini)
        }
    }

    //SETTA IL DATASOURCE DELLA TABELLA TRAMITE CHIAMATA API
    useEffect(() => {
        getListini(setListiniDataSource)
        if (grid) {
            grid.refresh()
        }
    }, [])

    useEffect(() => {
        popolaPrezzo()
        grid.refresh()
    }, [listiniDataSource])


    // INIZIO JSX 
    return (
        <>
            <Card>
                <CardBody>
                    <GridComponent
                        rowHeight={26}
                        dataSource={listiniDataSource}
                        allowPaging={true}
                        rowSelected={rowSelected}
                        selectionSettings={{ checkboxMode: 'ResetOnRowClick', enableToggle: true, checkboxOnly: true }}
                        allowSelection={true}
                        allowFiltering={true}
                        showColumnChooser={true}
                        toolbar={toolbarCustomItem}
                        allowPdfExport
                        allowExcelExport={true}
                        filterSettings={{ type: "Menu" }}
                        allowSorting={true} editSettings=
                        {{
                            allowEditing: false,
                            allowDeleting: true
                        }}
                        ref={g => (grid = g)}
                        toolbarClick={clickHandler}
                        commandClick={customButton}
                    >

                        <ColumnsDirective>
                            <ColumnDirective type='checkbox' width='30' />
                            <ColumnDirective field='azioni' width='120' textAlign="left" showInColumnChooser={false} allowFiltering={false} commands={constructor.commands} displayHtmlEncode={false} />
                            <ColumnDirective field='id' width='30' visible={false} isPrimaryKey={true} />
                            <ColumnDirective field='nome' width='200' textAlign="center" clipMode='EllipsisWithTooltip' />
                            <ColumnDirective field='predefinito' width='100' template={predefinitoTemplate} />
                            <ColumnDirective field='abilitato' width='100' template={abilitatoTemplate} />
                            <ColumnDirective field='formula' width='250' />
                            <ColumnDirective field='prezzo' format={'c2'} visible={props.costo !== undefined} width='100' headerText='prezzo' />
                        </ColumnsDirective>
                        <Inject services={[Page, Sort, Filter, Group, CommandColumn, Edit, Toolbar, ColumnChooser, Selection, ExcelExport, PdfExport]} />
                    </GridComponent>
                </CardBody>
            </Card>
            {/* DA QUI IN POI C'E' SOLAMENTE LA MODAL CHE UTILIZZO PER AGGIORNARE IL LISTINO O PER CREARNE UNO NUOVO */}
            {/* DA QUI IN POI C'E' SOLAMENTE LA MODAL CHE UTILIZZO PER AGGIORNARE IL LISTINO O PER CREARNE UNO NUOVO */}
            {/* DA QUI IN POI C'E' SOLAMENTE LA MODAL CHE UTILIZZO PER AGGIORNARE IL LISTINO O PER CREARNE UNO NUOVO */}
            <div className='demo-inline-spacing'>
                <div className='vertically-centered-modal'>
                    <Modal isOpen={basicModal} className='modal-dialog-centered' toggle={() => {
                        setBasicModal(!basicModal)
                    }}>
                        <Form onSubmit={handleSubmit(onSubmit, onError)}>
                            <ModalHeader toggle={() => {
                                reset()
                                setBasicModal(!basicModal)
                            }}>Modifica Listino</ModalHeader>
                            <ModalBody>
                                <Row>
                                    <Col className='mb-2' xl='6' md='6' sm='6'>
                                        <Label className='form-label' for='nome'>
                                            Nome Listino
                                        </Label>
                                        <Controller
                                            id='nome'
                                            name='nome'
                                            defaultValue={state.nome}
                                            control={control}
                                            render={({ field: { value, onChange, ...field } }) => <Input {...field} onChange={({ target: { value } }) => {
                                                onChange(value);
                                                dispatch({ type: 'MODIFICA_NOMELISTINO', payload: value })
                                            }}
                                                value={state.nome}
                                                invalid={errors.nome && true} />}
                                        />
                                        {errors.nome && <FormFeedback>{errors.nome.message}</FormFeedback>}
                                    </Col>
                                    <Col className='mb-2' xl='6' md='6' sm='6'>
                                        <Label for='abilitatoSwitch' className='form-check-label'>
                                            Abilitato
                                        </Label>
                                        <div className='form-switch form-check-primary'>

                                            <Input type='switch' id='abilitatoSwitch' name='abilitato' value={state.abilitato} onClick={(e) => { dispatch({ type: 'MODIFICA_ABILITATO', payload: e }) }} defaultChecked={state.abilitato === 1 ? true : false} />
                                        </div>
                                        <Label for='predefinitoSwitch' className='form-check-label'>
                                            Predefinito
                                        </Label>
                                        <div className='form-switch form-check-primary'>

                                            <Input type='switch' id='predefinitoSwitch' name='predefinito' value={state.predefinito} onClick={(e) => { dispatch({ type: 'MODIFICA_PREDEFINITO', payload: e }) }} defaultChecked={state.predefinito === 1 ? true : false} />
                                        </div>
                                    </Col>
                                </Row>
                                <Col className='mb-2'>
                                    <Label className='form-label' for='magazzino'>
                                        Inserisci il listino base da cui vuoi partire
                                    </Label>
                                    <Controller
                                        name='valorePartenza'
                                        className='react-select'
                                        classNamePrefix='select'
                                        control={control}
                                        render={({ field: { value, onChange, ...field } }) => <Select
                                            {...field}
                                            value={optionsPartenza.filter(optionsPartenza => optionsPartenza.value === state.valorePartenza)}
                                            options={optionsPartenza}
                                            isClearable={false}
                                            onChange={(e) => {
                                                onChange(e.value);
                                                dispatch({ type: 'MODIFICA_VALOREPARTENZA', payload: e.value })
                                            }}
                                            invalid={errors.valorePartenza && true} />}
                                    />
                                </Col>
                                <div className='demo-inline-spacing'>
                                    <div className='form-check'>
                                        <Input type='radio' id='ex1-active' name='ex1' onClick={(e) => { dispatch({ type: 'MODIFICA_MOVIMENTAZIONEPERCENTUALE', payload: e }) }} defaultChecked={state.movimentazionePercentuale === '+' ? true : false} />
                                        <Label className='form-check-label' for='ex1-active'>
                                            Aumenta
                                        </Label>
                                    </div>
                                    <div className='form-check'>
                                        <Input type='radio' name='ex1' id='ex1-inactive' onClick={(e) => { dispatch({ type: 'MODIFICA_MOVIMENTAZIONEPERCENTUALE', payload: e }) }} defaultChecked={state.movimentazionePercentuale === '-' ? true : false} />
                                        <Label className='form-check-label' for='ex1-inactive'>
                                            Diminuisci
                                        </Label>
                                    </div>
                                </div>
                                <InputGroup className=''>
                                    <Controller
                                        type='number'
                                        id='valorePercentuale'
                                        name='valorePercentuale'
                                        defaultValue={state.valorePercentuale}
                                        control={control}
                                        render={({ field: { value, onChange, ...field } }) => <Input {...field} onChange={({ target: { value } }) => {
                                            onChange(value);
                                            dispatch({ type: 'MODIFICA_VALOREPERCENTUALE', payload: value })
                                        }}
                                            value={state.valorePercentuale}
                                            invalid={errors.valorePercentuale && true} />}
                                    />
                                    <InputGroupText>%</InputGroupText>
                                    {errors.valorePercentuale && <FormFeedback>{errors.valorePercentuale.message}</FormFeedback>}
                                </InputGroup>
                                <div className='demo-inline-spacing'>
                                    <div className='form-check'>
                                        <Input type='radio' id='ex2-active' name='ex2' onClick={(e) => { dispatch({ type: 'MODIFICA_MOVIMENTAZIONEEURO', payload: e }) }} defaultChecked={state.movimentazioneEuro === '+' ? true : false} />
                                        <Label className='form-check-label' for='ex2-active'>
                                            Aumenta
                                        </Label>
                                    </div>
                                    <div className='form-check'>
                                        <Input type='radio' name='ex2' id='ex2-inactive' onClick={(e) => { dispatch({ type: 'MODIFICA_MOVIMENTAZIONEEURO', payload: e }) }} defaultChecked={state.movimentazioneEuro === '-' ? true : false} />
                                        <Label className='form-check-label' for='ex2-inactive'>
                                            Diminuisci
                                        </Label>
                                    </div>
                                </div>
                                <InputGroup className=''>
                                    <Controller
                                        type='number'
                                        id='valoreEuro'
                                        name='valoreEuro'
                                        defaultValue={state.valoreEuro}
                                        control={control}
                                        render={({ field: { value, onChange, ...field } }) => <Input {...field} onChange={({ target: { value } }) => {
                                            onChange(value);
                                            dispatch({ type: 'MODIFICA_VALOREEURO', payload: value })
                                        }}
                                            value={state.valoreEuro || ''}
                                            invalid={errors.valoreEuro && true} />}
                                    />
                                    <InputGroupText>%</InputGroupText>
                                    {errors.valoreEuro && <FormFeedback>{errors.valoreEuro.message}</FormFeedback>}
                                </InputGroup>
                                <p>{state.valorePartenza + ' ' + state.movimentazionePercentuale + ' ' + state.valorePercentuale + ' % ' + state.movimentazioneEuro + ' ' + state.valoreEuro + ' Euro'}</p>
                            </ModalBody>
                            <ModalFooter>
                                <Button type='Submit' color='primary' >
                                    Salva
                                </Button>
                            </ModalFooter>
                        </Form>
                    </Modal>
                </div>
            </div>
        </>
    )
}

export default DetailsPricesAndList